import React from "react";
import { useTranslation } from "react-i18next";
import GeneralButton from "../Buttons/GeneralButton";
import Modal from "./Modal";

interface ConfirmationPopupProps {
  title: string;
  description: string;
  isModalOpen: boolean;
  okayBtColor?: "blue" | "red" | "lite";
  okayBtText?: string;
  onClose: () => void;
  onConfirm: () => void;
  ariaLabel?: string;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  title,
  ariaLabel = "Confirmation",
  description,
  isModalOpen,
  okayBtColor = "blue",
  okayBtText = "continue",
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isModalOpen}
      onClose={onClose}
      header={title}
      ariaLabel={ariaLabel}
    >
      <p className="text-body-text mb-6 text-xl" id="modal-description">
        {description}
      </p>
      <div className="flex w-full justify-between">
        <GeneralButton
          fontColor="body-text"
          title={t("cancel")}
          color="lite"
          onClick={onClose}
          ariaLabel={t("cancel")}
        />
        <GeneralButton
          title={<>{t(okayBtText)}</>}
          color={okayBtColor}
          onClick={onConfirm}
        />
      </div>
    </Modal>
  );
};

export default ConfirmationPopup;
